import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { Form } from "antd/es";
import { IWithSDProps, withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import KuikaSwitch from "../../../../ui-kit/kuika-switch/kuika-switch";
import { ConfigField } from "../config-pane-parts";

export interface IAppSettingsRunIsProdState {}

export interface IAppSettingsRunIsProdProps {}

class AppSettingsRunIsProd extends PureSdComponent<
  IAppSettingsRunIsProdProps & IWithSDProps,
  IAppSettingsRunIsProdState
> {
  constructor(props: IAppSettingsRunIsProdProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  render(): React.ReactNode {
    return (
      <ConfigField label="Is Prod Mode Enabled" tooltipContentKey="runsettings_build_type_is_prod_mode_enabled">
        <Form.Item name={["webConfig", "isProdModeEnabled"]} valuePropName="checked" noStyle>
          <KuikaSwitch />
        </Form.Item>
      </ConfigField>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const appSettingsRunIsProd = withSD<IAppSettingsRunIsProdProps>(AppSettingsRunIsProd);
export { appSettingsRunIsProd as AppSettingsRunIsProd };
